// Sidebar.js
import React, { useContext } from 'react';
import {
  Box,
  VStack,
  Link,
  Button,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton
} from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FaCog, FaQuestionCircle } from 'react-icons/fa';
import { LuActivity } from 'react-icons/lu';
import { getAuth, signOut } from 'firebase/auth';
import { firebase } from './firebaseConfig';
import { AuthContext } from './AuthContext';
import designImage from './img/ekkos-logo.png';
import { trackEvent } from './analytics';

const Sidebar = ({ isCollapsed, onToggle }) => {

  const location = useLocation();
  const { user } = useContext(AuthContext);

  const handleLogout = async () => {
    try {
      const auth = getAuth(firebase);
      await signOut(auth);
      const { fetchWithoutAuth } = await import('./apiClient');
  await fetchWithoutAuth('/firebase/logout', { method: 'POST' });
      trackEvent('auth_logout', { source: 'sidebar' });
      // Optionally, you can add any post-logout logic here
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  
  return (
    <>
      <Drawer isOpen={!isCollapsed} placement="left" onClose={onToggle} size="xs">
        <DrawerOverlay />
        <DrawerContent
          bg="bg.surface"
          color="text.primary"
          borderColor="border.subtle"
          boxShadow="2xl"
        >
          <DrawerCloseButton />
          <Box display="flex" flexDirection="column" justifyContent="space-between" h="100%" p={5}>
            <Box mb={6} display="flex" alignItems="center">
              <img
                src={designImage}
                alt="Ekkos Logo"
                style={{ maxHeight: '64px', maxWidth: '160px', objectFit: 'contain' }}
              />
            </Box>
            <VStack spacing={4} align="flex-start" w="100%">
              <Link
                as={RouterLink}
                to="/"
                fontSize="lg"
                fontWeight={location.pathname === '/' ? 'bold' : 'normal'}
                _hover={{ textDecoration: 'none', color: 'text.subtle' }}
                display="flex"
                alignItems="center"
                w="100%"
                color="text.primary"
              >
                <LuActivity style={{ marginRight: '8px' }} />
                {'Tasks'}
              </Link>
              {/* 
              <Link
                as={RouterLink}
                to="/tasks"
                fontWeight={location.pathname === '/tasks' ? 'bold' : 'normal'}
                _hover={{ textDecoration: 'none', color: 'text.subtle' }}
                display="flex"
                alignItems="center"
                w="100%"
              >
                <FaTasks style={{ marginRight: '8px' }} />
                {'Tasks'}
              </Link>
              */}
              <Link
                as={RouterLink}
                to="/settings"
                fontWeight={location.pathname === '/settings' ? 'bold' : 'normal'}
                _hover={{ textDecoration: 'none', color: 'text.subtle' }}
                display="flex"
                alignItems="center"
                w="100%"
                color="text.primary"
              >
                <FaCog style={{ marginRight: '8px' }} />
                {'Settings'}
              </Link>
              <Link
                as={RouterLink}
                to="/help-feedback"
                fontWeight={location.pathname === '/help-feedback' ? 'bold' : 'normal'}
                _hover={{ textDecoration: 'none', color: 'text.subtle' }}
                display="flex"
                alignItems="center"
                w="100%"
                color="text.primary"
              >
                <FaQuestionCircle style={{ marginRight: '8px' }} />
                {'Help & Feedback'}
              </Link>
            </VStack>
            {user && (
              <Button colorScheme="red" onClick={handleLogout} w="100%">
                Log Out
              </Button>
            )}
          </Box>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Sidebar;
